module.exports = __webpack_public_path__ + "static/img/zt2-pic1.29c5199.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/advertisement/zt2-pic1.jpg
// module id = wd5O
// module chunks = 171